module.exports = __webpack_public_path__ + "img/notifications_white.3e0d7caf.svg";